var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"titulo insuficiente\">\r\n    <h2> <strong>Tu cuenta no tiene Acceso Digital.</strong>Suscribite y accedé a la edición impresa en PDF.</h2>\r\n</div>  ";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./Statics/scripts/paywall/views/partials/header/pdf_sin_suscripcion.hbs
// module id = 520
// module chunks = 0